export default { sha: 'df47f2de9fb45a9f79f7d07dd3a622287b43f5cd', buildNumber: 'undefined' }
